import { type Olympus } from '@owner/olympus-client'
import { type ActionContext } from 'vuex'

import { type CoreModule } from '@/lib/store/types'

import {
  type BlockCore,
  type BuilderState,
  type ResourceCore,
} from '../../types'

export const blockAdd = async <
  TResource extends ResourceCore,
  TBlock extends BlockCore,
>(
  {
    state,
    commit,
    dispatch,
  }: ActionContext<BuilderState<TResource, TBlock>, CoreModule>,
  payload: Olympus.Funnel.Section
): Promise<void> => {
  commit('_builder_BLOCK_ADD', payload)
}
